var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckupSuccessFilled = function SvgCheckupSuccessFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9832 109.067C69.0896 109.675 70.3864 109.675 71.4928 109.067C78.6742 105.121 105.446 89.1288 105.446 69.999C105.446 64.7257 105.379 50.0278 105.33 40.0431C105.303 34.5712 100.888 30.1471 95.4164 30.1114C87.6035 30.0603 76.8553 30 69.738 30C63.1458 30 52.02 30.0621 43.9304 30.1135C38.4329 30.1485 34.0041 34.6154 34.0087 40.113C34.0169 49.8394 34.028 64.04 34.028 69.999C34.028 89.1289 60.8015 105.121 67.9832 109.067Z",
    fill: "#80BD64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.192 64.964L64.033 77.493L89.185 50.5229",
    stroke: "white",
    strokeWidth: 6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckupSuccessFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "checkup-success-filled.af0e2fab7bab3936b1dd02d47808f288.svg";